import React, { useEffect, useState } from 'react'

import 'typeface-montserrat';
import '@fortawesome/fontawesome-free/css/all.css'
import 'mapbox-gl/dist/mapbox-gl.css';
import './app.css';

import ErrorContext, { useErrors } from 'ErrorContext'

import AuthTokenContext from 'AuthTokenContext'
import useAuthTokens from 'hooks/useAuthTokens'

import Routes from 'Routes'

function App() {
    const tokens = useAuthTokens()
    const errors = useErrors()

    document.title = window.skin.site_name;
    const [loaded, setLoaded] = useState(false)
 
    useEffect(() => {
        if(tokens.loaded) {
            setLoaded(true);
        } else {
            setLoaded(false);
        }
    }, [tokens, errors])

    if(!loaded) {
        return <div>Loading...</div>
    }

    return (
        <ErrorContext.Provider value={errors}>
            <AuthTokenContext.Provider value={tokens}>
            { tokens.loaded &&
                <Routes />
            }
            </AuthTokenContext.Provider>
        </ErrorContext.Provider>
    );
}

export default App;
